import React from "react";

/**
 * Context to hold the current Firebase signed in user
 * @type {React.Context<null>}
 */
const FirebaseAuthContext = React.createContext(null);

export default FirebaseAuthContext;
